import { TagPanelController } from '../controller/TagPanelController';
import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';
import { TagActionContext } from '../../common/types/TagActionContext';

export class TagPanelWebComponent extends BaseWebComponentElement {
  public controller!: TagPanelController;
  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: TagPanelController,
    });
  }

  public get context(): TagActionContext {
    const context = this.getAttribute('context');

    if (!context) {
      throw new Error('[TagPanel] "context" not provided as an attribute.');
    }

    if (!TagActionContext.isValid(context)) {
      throw new Error(`[TagPanel] context not valid: ${context}`);
    }

    return context as TagActionContext;
  }

  public get editedTagId(): string {
    const editedTagId = this.getAttribute('editedTagId');

    if (!editedTagId) {
      throw new Error('[TagPanel] "editedTagId" not provided as an attribute.');
    }

    return editedTagId;
  }

  public get clonedTagId(): string {
    const clonedTagId = this.getAttribute('clonedTagId');

    if (!clonedTagId) {
      throw new Error('[TagPanel] "clonedTagId" not provided as an attribute.');
    }

    return clonedTagId;
  }

  public get clonedTagName(): string {
    const clonedTagName = this.getAttribute('clonedTagName');

    if (!clonedTagName) {
      throw new Error('[TagPanel] "clonedTagName" not provided as an attribute.');
    }

    return clonedTagName;
  }

  public get clonedTagCompanyName(): string {
    const clonedTagCompanyName = this.getAttribute('clonedTagCompanyName');

    if (!clonedTagCompanyName) {
      throw new Error('[TagPanel] "clonedTagCompanyName" not provided as an attribute.');
    }

    return clonedTagCompanyName;
  }

  public get hasUnsavedChanges(): boolean {
    return this.controller.view.hasUnsavedChanges;
  }
}
